
import HelpCenter from '@/components/help-center.vue'
import { Vue, Component } from 'vue-property-decorator'
import {
  getAccountStatusI18n,
  getAccountStatusColor,
  getAccountStatusItem
} from '@/const/state/account'
import HeaderNav from '@/components/header-nav.vue'
import BytedIconTipsOne from '@byte-design/vue-icons/icons/TipsOne'
import { State, Action } from 'vuex-class'

const namespace = 'account'
@Component({
  name: 'account-info',
  components: {
    HeaderNav,
    HelpCenter,
    BytedIconTipsOne
  }
})
export default class AccountInfo extends Vue {
  chosenId = ''
  punishReasonReady = false
  @State('accountInfo', { namespace }) accountInfo: any
  @State('punishInfo', { namespace }) punishInfo: any
  @Action('loadPunishInfo', { namespace }) loadPunishInfo: Function

  mounted() {
    this.chosenId = this.accountInfo.id
    if (this.accountInactive) {
      this.loadPunishInfo({
        aadvid: this.chosenId
      }).then(() => {
        this.punishReasonReady = true
      })
    }
  }

  handleCancel(): void {
    this.$router.back()
  }

  get accountStatusColor(): string {
    return getAccountStatusColor(+this.accountInfo.status)
  }

  get accountDisabled(): boolean {
    return getAccountStatusItem(+this.accountInfo.status).label == 'disable'
  }
  get accountStatus(): string {
    return this.$t(getAccountStatusI18n(+this.accountInfo.status))
  }

  get accountInactive(): boolean {
    return getAccountStatusItem(+this.accountInfo.status).label == 'inactive'
  }
  get rejReason(): string {
    if (this.punishReasonReady) {
      return this.punishInfo?.reason || ''
    }
    if (this.accountDisabled) {
      return this.accountInfo?.reject_reason || ''
    }
    return ''
  }
}
